import React from 'react';

const stripCitations = (text) => text.replace(/\[\d+\]/g, '').trim();

const AIContinueConversation = ({ suggestedPrompts, handlePromptClick }) => {
    if (!suggestedPrompts || suggestedPrompts.length === 0) return null;

    return (
        <div className="ai-continue-conversation">
            <p className="ai-continue-conversation__heading">Would you like to know more?</p>
            <ul className="ai-continue-conversation__list">
                {suggestedPrompts.map((prompt, index) => {
                    const cleanPrompt = stripCitations(prompt);
                    return (
                        <li key={index} className="ai-continue-conversation__item">
                            <button
                                className="ai-continue-conversation__link"
                                onClick={() => handlePromptClick(prompt)}
                                aria-label={`Continue conversation: ${cleanPrompt}`}
                            >
                                {cleanPrompt}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default AIContinueConversation;
